var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStudyMaterial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_3387",
    "data-name": "\\uADF8\\uB8F9 3387",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.709,
    height: 14.912,
    viewBox: "0 0 11.709 14.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1451",
    "data-name": "\\uC0AC\\uAC01\\uD615 1451",
    width: 11.709,
    height: 14.912,
    fill: "#19325f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3386",
    "data-name": "\\uADF8\\uB8F9 3386",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2724",
    "data-name": "\\uD328\\uC2A4 2724",
    d: "M0,13.546V1.365c.012-.035.027-.07.036-.106A1.6,1.6,0,0,1,.946.144,3.959,3.959,0,0,1,1.364,0H8.648a1.805,1.805,0,0,1,.269.186q1.31,1.3,2.613,2.61a.583.583,0,0,1,.179.432q0,5.042,0,10.084a1.585,1.585,0,0,1-1.581,1.6q-4.274.009-8.548,0a1.594,1.594,0,0,1-1.5-1.1c-.029-.088-.055-.177-.081-.266M7.451,1.065H1.709c-.461,0-.645.183-.645.644q0,5.748,0,11.5c0,.451.186.64.633.64h8.314c.446,0,.633-.189.633-.64q0-4.376,0-8.751V4.26H9.153a1.609,1.609,0,0,1-1.7-1.7c0-.493,0-.985,0-1.5m1.064.256c0,.45,0,.887,0,1.325a.517.517,0,0,0,.555.549c.4,0,.809,0,1.213,0a.58.58,0,0,0,.092-.013L8.515,1.321",
    fill: "#19325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2725",
    "data-name": "\\uD328\\uC2A4 2725",
    d: "M1.364,0A3.948,3.948,0,0,0,.946.144a1.6,1.6,0,0,0-.91,1.115c-.009.036-.024.07-.036.106V0Z",
    fill: "#19325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2726",
    "data-name": "\\uD328\\uC2A4 2726",
    d: "M22.118,38.971c-.876,0-1.751,0-2.627,0a.53.53,0,0,1-.518-.74.521.521,0,0,1,.516-.324h1.6q1.829,0,3.658,0a.533.533,0,1,1,0,1.065H22.118",
    transform: "translate(-16.267 -32.581)",
    fill: "#19325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2727",
    "data-name": "\\uD328\\uC2A4 2727",
    d: "M22.135,57.925c-.881,0-1.763,0-2.644,0a.531.531,0,0,1-.143-1.048.622.622,0,0,1,.148-.015q2.635,0,5.271,0a.533.533,0,0,1,.543.4.5.5,0,0,1-.234.573.771.771,0,0,1-.347.085c-.865.007-1.729,0-2.594,0",
    transform: "translate(-16.279 -48.873)",
    fill: "#19325f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2728",
    "data-name": "\\uD328\\uC2A4 2728",
    d: "M22.115,76.877c-.876,0-1.751,0-2.627,0a.53.53,0,0,1-.514-.743.523.523,0,0,1,.518-.321h2.1q1.58,0,3.159,0a.533.533,0,1,1,0,1.065q-1.314,0-2.627,0",
    transform: "translate(-16.268 -65.162)",
    fill: "#19325f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStudyMaterial);
export default __webpack_public_path__ + "static/media/icon-Study-Material.7ae143c8f9f9dbd4cc6c20a1018d96c9.svg";
export { ForwardRef as ReactComponent };